import React from "react"
import { Table } from "react-bootstrap"

function AssetTable({ 
  data, 
  showModel, 
  columns,        
  emptyMessage, 
  statusOptions 
}) {
  const getTdClass = (baseClass, value) => {
    const isDefault = value === "N/A" || value === "-"
    return `${baseClass} ${isDefault ? "td-align-center" : ""}`
  }

  return (
    <Table hover responsive>
      <thead className="table-header-gray">
        <tr>
          {columns.map((col, idx) => (
            <th key={idx}><span className="th-header-text">{col.header}</span></th>
          ))}
        </tr>
      </thead>
      <tbody>
        {data?.map((model, index) => (
          <tr
            onClick={() => showModel(model.uid)}
            className="cursor-pointer"
            key={index}
          >
            {columns.map((col, idx) => {
              const value = col.render(model)
              return (
                <td key={idx} className={getTdClass("td-text-limited", value)}>
                  {value}
                </td>
              )
            })}
          </tr>
        ))}

        {!data?.length && (
          <tr>
            <td colSpan={columns.length} className="td-text-limited td-text-limited-space">
              {emptyMessage}
            </td>
          </tr>
        )}
      </tbody>
    </Table>
  )
}

export default AssetTable
